import { render } from "./ModalConfirmarReserva.vue?vue&type=template&id=c7213aca"
import script from "./ModalConfirmarReserva.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarReserva.vue?vue&type=script&lang=js"

import "./ModalConfirmarReserva.vue?vue&type=style&index=0&id=c7213aca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__